import * as Dialog from '@radix-ui/react-dialog';
import React from 'react';

import {
  DialogClose,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogOverlay,
  DialogTitle,
} from '@/components/ui/dialog';
import { cn } from '@/utils';

type Props = {
  trigger: JSX.Element;
  title?: JSX.Element | string;
  description?: JSX.Element | string | undefined;
  content: JSX.Element;
  width?: 'sm' | 'ml';
};

export const Modal: React.FC<Props> = ({
  trigger,
  title,
  description,
  content,
  width = 'sm',
}) => {
  const hasTitle = title !== undefined;
  const hasDescription = description !== undefined;

  return (
    <Dialog.Root>
      <Dialog.Trigger asChild>{trigger}</Dialog.Trigger>
      <Dialog.Portal>
        <DialogOverlay />
        <DialogContent
          className={cn('w-[calc(100vw-theme(space.8))]', {
            'max-w-screen-sm': width === 'sm',
            'max-w-screen-ml': width === 'ml',
          })}
        >
          {hasTitle ? (
            <DialogHeader>
              <DialogTitle>{title}</DialogTitle>
              {hasDescription ? (
                <DialogDescription>{description}</DialogDescription>
              ) : null}
            </DialogHeader>
          ) : null}

          {content}

          <DialogClose />
        </DialogContent>
      </Dialog.Portal>
    </Dialog.Root>
  );
};
